
import Vue from 'vue';

import { store } from '@/store'
import { mapState } from 'vuex';

import VarianteQueryResult from '@/models/VarianteQueryResult'


export const KombiRepository = new Vue({

	store,
	data: function () {
		return {
			className: 'KombiRepository',
			globalCriteria: {},
			data: []
		}
	},
	computed: {
		...mapState('settings', ['presets']),
		...mapState('configurator', ['configurator', 'kombis', 'komponenten']),
	},

	methods: {

		/**
		 * 	Setzt Filter, die für ALLE Queries an dieses Repository gelten.
		 * 	
		 */
		setGlobalCriteria ( criteria ) {
			this.globalCriteria = criteria;
		},
		
		/**
		 * 	Holt Filter, die für ALLE Queries an dieses Repository gelten.
		 * 	
		 */
		getGlobalCriteria () {
			return this.globalCriteria;
		},
		
		unsetGlobalCriteria () {
			this.globalCriteria = {};
		},

		/**
		 * 	Ein <Kombi>-Model in das data-Array einfügen
		 * 
		 */
		add( model ) {
			this.$store.commit('configurator/ADD_KOMBI', model);
		},

		/**
		 * 	Query an dieses Repository:
		 * 	Alle <Kombi> dieses Repositories holen
		 * 	
		 */
		findAll() {
			return this.kombis || [];
		},

		/**
		 * 	Query an dieses Repository:
		 * 	Filtert alle <Kombi> nach vorgegebenen Kritierien.
		 * 	
		 */
		findByCriteria( criteria ) {
			var criteria = Object.assign({}, this.globalCriteria, criteria);
			var results = [];
			this.findAll().forEach((kombi) => {
				if (kombi.matches( criteria )) {
					results.push( kombi );
				}
			});
			return results;
		},

		/**
		 * 	Filtert alle <Kombi> nach Kriterien, dabei werden Varianten
		 * 	eines bestimmten Bereichs zurückgegeben, inkl. Info ob und
		 * 	wenn nein, warum nicht die Variante in dieser Kombi verwendbar
		 * 	ist.
		 *
		 * 	Beispiel:
		 * 	findVariants({bereich:'nasal'}, 'flasche');
		 * 
		 * 	Gibt [<Variante>, ...] zurück
		 */
		findVariants( criteria, optionName ) {

			var results = [];

			// Vorgefilterte Ergebnisse, aber NUR unter Berücksichtigung der globalen Filterkritieren z.B. ({bereich:'nasal'})
			var preFilteredResults = this.findByCriteria({});

			// Welche möglichen Optionen gäbe es grundsätzlich für die Eigenschaft kombi[optionName]?
			var uniqueOptions = {}; 
			preFilteredResults.forEach((kombi) => {
				if (!kombi[optionName]) return;
				uniqueOptions[kombi[optionName].typ] = kombi;
			});

			// ... und wenn die einzelne Option gesetzt wäre ...
			Object.keys(uniqueOptions).forEach((key) => {

				var opt = {};
				opt[optionName] = key;
				
				var filteredResults = this.findByCriteria(Object.assign({}, criteria, opt));

				if (filteredResults.length) {

					// Es gibt für die Filter eine passende Kombi!
					var data = {
						selectable: true,
						conflicts: {},
						result: filteredResults[0],
					};
				} else {

					// Es gibt für die Filter KEINE passende Kombi
					var conflicts = {};

					// Wir erstellen eine Liste aller Filter-Kombinationen...
					var keyCombinations = this.getKeyCombinations( criteria );

					// ... und entfernen so lange Filter-Kriterien ...
					keyCombinations.forEach((keyArr) => {
						if (Object.keys(conflicts).length) return;
						var criteriaClone = Object.assign({}, criteria, opt);
						keyArr.forEach((k) => {
							delete(criteriaClone[k]);
						});

						// ... bis wir ein Ergebnis bekommen!
						if (this.findByCriteria(criteriaClone).length) {
							keyArr.forEach((k) => {
								conflicts[k] = criteria[k];
							});
						}
					});

					// Jetzt wissen wir, welche Filterkritierien sich quer gestellt haben!
					var data = {
						selectable: false,
						conflicts: conflicts,
						result: uniqueOptions[key],
					};
				}
				results.push( new VarianteQueryResult( data ) );
			});
			
			return results;
		},

		/**
		 * 	Alle Kombinationsmöglichkeiten eines Arrays zurückgeben.
		 * 	Beispiel:
		 * 	[1,2,3]	=> [[1], [2], [3], [1,2], [1,3], [2,3]];
		 */
		getKeyCombinations( obj ) {
			var arr = Object.keys( obj );
			let i, j, temp
			let result = []
			let arrLen = arr.length
			let power = Math.pow
			let combinations = power(2, arrLen)
			for (i = 0; i < combinations; i++) {
				temp = [];
				for (j = 0; j < arrLen; j++) {
					// & is bitwise AND
					if ((i & power(2, j))) {
						temp.push(arr[j]);
					}
				}
				if (temp.length) result.push(temp)
			}
			return result
		},
	}
});


// WEBPACK FOOTER //
// ./src/repositories/KombiRepository.js